<template>
  <div>
    <v-app-bar class="mb-1">
      <img
        :src="require('../../assets/logo_qclass_q_png.png')"
        alt="Logo empresa"
        height="35x"
        max-height="60px"
        contain
      >
      <v-spacer />
      <span class="font-weight-light mr-2 text-wrap">
        <strong>{{ getNameAluno }}</strong>
        em Autoescola
        <strong> {{ getNameCfc }}</strong>
      </span>
      <v-btn
        icon
        color="#ED2141"
        @click="Logout"
      >
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <NavigationPath />
  </div>
</template>
<script>
import NavigationPath from './NavigationPath';

export default {
  components:{
    NavigationPath,
  },
  props: {
    empresa: {
      type: Object,
    },
  },
  computed:{
    getNameAluno(){
      const aluno = this.$store.getters.getAluno;
      if(aluno.nome !== undefined){
        const [nome] = aluno.nome.split(' ');
        return nome;
      }
      return 'Aluno';
    },
    getNameCfc(){
      const cfc = this.$store.getters.getCfc;

      if(cfc.nome !== undefined){
        const [nome] = cfc.nome.split(' ');
        return nome;
      }
      return 'CFC';
    },
    getFotoAluno() {
      const image = this.$store.getters.getAluno.foto;

      if (image) {
        return `data:image/png;base64, ${image}`;
      }

      return require('../../assets/icon_user.png');
    }
  },
  methods:{
    Logout(){
      this.$store.commit('updateCfc',{});
      this.$store.commit('updateAluno', {});
      localStorage.removeItem('token');
      localStorage.removeItem('codeCfc');
      localStorage.removeItem('cpf');
      this.$router.push('/login');
    }
  },
};
</script>
